import { Bounce, ToastOptions, TypeOptions, toast } from "react-toastify";

import { NotificationProvider } from "@refinedev/core";

export const notificationProvider: NotificationProvider = {
  open: ({ key, message, description, type }) => {
    const typeMap: Record<string, TypeOptions> = {
      success: "success",
      error: "error",
      info: "info",
      warning: "warning",
      progress: "default",
    };

    const toastMessage = description ? `${message}\n${description}` : message;

    toast(toastMessage, {
      toastId: key,
      type: typeMap[type ?? "default"],
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      transition: Bounce,
    } as ToastOptions);
  },
  close: key => toast.dismiss(key),
};
